/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminListingCheckStatus,
    AdminListingCheckStatusFromJSON,
    AdminListingCheckStatusFromJSONTyped,
    AdminListingCheckStatusToJSON,
} from './AdminListingCheckStatus';

/**
 * 
 * @export
 * @interface AdminListingCheck
 */
export interface AdminListingCheck {
    /**
     * 
     * @type {string}
     * @memberof AdminListingCheck
     */
    checkedAt: string;
    /**
     * Condition as the marketplace shows it, e.g. "Open box".
     * @type {string}
     * @memberof AdminListingCheck
     */
    condition?: string;
    /**
     * Price on the marketplace; a live listing's price is copied into ours.
     * @type {number}
     * @memberof AdminListingCheck
     */
    price?: number;
    /**
     * 
     * @type {AdminListingCheckStatus}
     * @memberof AdminListingCheck
     */
    status: AdminListingCheckStatus;
}



export function AdminListingCheckFromJSON(json: any): AdminListingCheck {
    return AdminListingCheckFromJSONTyped(json, false);
}

export function AdminListingCheckFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminListingCheck {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checkedAt': json['checkedAt'],
        'condition': !exists(json, 'condition') ? undefined : json['condition'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'status': AdminListingCheckStatusFromJSON(json['status']),
    };
}

export function AdminListingCheckToJSON(value?: AdminListingCheck | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'checkedAt': value.checkedAt,
        'condition': value.condition,
        'price': value.price,
        'status': AdminListingCheckStatusToJSON(value.status),
    };
}

